export default {
    dzsc: 'https://mall.tpre.cn/#/home',
    lzh: ' https://mall.tpre.cn/#/shopList?id=1556821317596057602&name=%E8%80%81%E5%AD%97%E5%8F%B7',
    xycgr: 'https://trade.tpre.cn/user-center-view/login?type=login&mode=ticket&identity=purchaser&redirect=https://cloud.tpre.cn/api/ep/hy/ossi/sso/auth/purchaser',
    dpsq: 'https://trade.tpre.cn/user-center-view/login?type=login&mode=ticket&identity=mallshop&redirect=https://cloud.tpre.cn/api/ep/hy/ossi/sso/auth/shop',
    zbdl: 'https://trade.tpre.cn/user-center-view/login?type=login&mode=ticket&identity=bidagency&redirect=https://cloud.tpre.cn/api/ep/hy/ossi/sso/auth/bidagency',
    gys: 'https://trade.tpre.cn/user-center-view/login?type=login&mode=ticket&identity=supplier&redirect=https://cloud.tpre.cn/api/ep/hy/ossi/sso/auth/supplier',
    zj: 'https://trade.tpre.cn/user-center-view/login?type=login&mode=ticket&identity=expert&redirect=https://cloud.tpre.cn/api/ep/hy/ossi/sso/auth/expert',
    smrz: 'https://trade.tpre.cn/user-center-view/login',
    sccgr: 'https://trade.tpre.cn/user-center-view/login?type=login&mode=ticket&identity=purchaser&redirect=https://mall.tpre.cn/%23/otherway',
    zjsccgr: 'https://zjxx.tpre.cn/#/login',
    zjxycgr: 'https://cloud.tpre.cn/login.html'
}



//////////////////
// WEBPACK FOOTER
// ./static/path.js
// module id = KzgS
// module chunks = 34